import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { METRIC_CARD_CATALOGUE } from '../lib/coachHealthTypes'

export function useMetricCardCopy() {
  const { t } = useTranslation()

  const labelFor = useCallback(
    (id: string) => t(`coach.metrics.cards.${id}`, { defaultValue: id }),
    [t],
  )

  const catalogue = METRIC_CARD_CATALOGUE.map((card) => ({
    ...card,
    label: labelFor(card.id),
  }))

  return { labelFor, catalogue }
}
